var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"pa-2",attrs:{"cols":"12","md":"12"}},[_c('Rate_work_college')],1),_c('v-col',{attrs:{"cols":"12"}},[_c('ExecutiveDashboard')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }